/* template */
<template><div class="es-search-history-container" v-if="(historyList.length)"><div class="es-search-record"><mpx-view v-for="(item, index) in (historyList)" :key="item.index" @tap="changeSelectCity(item)" class="es-search-record-item"><div>{{ item[0].name }} - {{ item[1].name }}</div></mpx-view></div><mpx-view @tap="clearHistoryList" class="es-clear-history">清除历史</mpx-view></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m2fc6ffb0"}'>
  @import '~@/mixins/stylus/color.styl'

  .es-search-history-container
    margin-top 9px
    height 21px
    display flex
    justify-content space-between
    color $train-color-999
    font-size 11px
    font-weight 400
    overflow hidden
    .es-clear-icon
      height 22px
      line-height 22px
      margin-right 1px
    .es-clear-history
      width 64px
      height 30px
      line-height 22px
      text-align center
    .es-search-record
      width calc(100% - 50px)
      height 21px
      margin-left 1px
      overflow scroll
      white-space nowrap
      .es-search-record-item
        margin-top 1px
        margin-left 1px
        height 19px
        line-height 19px
        border-radius 4px
        background #FFFFFF
        display inline-block
        margin-right 8px
        padding 0 6px
        z-index 2
        position relative
        box-shadow: 0px 0px 0px 0.5px #CCCCCC
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m2fc6ffb0"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./index.mpx.js?isComponent&outputPath=components%2Findex2fc6ffb0%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./index.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Findex2fc6ffb0%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m2fc6ffb0"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/index2fc6ffb0/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'mpx-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
